import { render, staticRenderFns } from "./assess-the-stress.vue?vue&type=template&id=6fc153e8&scoped=true&"
import script from "./assess-the-stress.vue?vue&type=script&lang=js&"
export * from "./assess-the-stress.vue?vue&type=script&lang=js&"
import style0 from "./assess-the-stress.vue?vue&type=style&index=0&id=6fc153e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc153e8",
  null
  
)

export default component.exports